"use client";

import { HelpCircle } from "lucide-react";
import { cn } from "../lib/utils";
import { Tooltip } from "./tooltip";

interface TooltipIconProperties {
  content: React.ReactNode;
  side?: "top" | "bottom" | "left" | "right";
  className?: string;
  iconClassName?: string;
}

export function TooltipIcon({
  content,
  side = "top",
  className,
  iconClassName,
}: TooltipIconProperties) {
  return (
    <Tooltip content={content} side={side} className={className}>
      <button
        type="button"
        className="inline-flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-strategy-gold/50 transition-colors"
        aria-label="More information"
      >
        <HelpCircle className={cn("h-4 w-4", iconClassName)} strokeWidth={2} />
      </button>
    </Tooltip>
  );
}
